import React from "react";
import { Link } from "react-router-dom";
import { UCAT_SECTIONS } from "../content";
import { Reveal } from "../hooks";

export function UCATSectionsOverview() {
  return (
    <section
      className="py-24 px-4 relative overflow-hidden"
      data-testid="sections-overview"
      style={{
        background:
          "linear-gradient(180deg, hsl(0 0% 100%) 0%, hsl(220 20% 98%) 50%, hsl(0 0% 100%) 100%)",
      }}
    >
      <div
        className="absolute bottom-0 left-0 w-[800px] h-[600px] pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at bottom left, hsla(221, 100%, 50%, 0.09) 0%, transparent 70%)",
        }}
      />
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="text-center mb-14">
            <div className="text-xs font-mono font-medium text-primary uppercase tracking-widest mb-3">
              COVERAGE
            </div>
            <h2 className="text-3xl sm:text-4xl font-cabinet font-black tracking-tight mb-4">
              All 4 UCAT Sections
            </h2>
            <p className="text-lg text-muted-foreground font-plex">
              Targeted practice for every part of the exam
            </p>
          </div>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {UCAT_SECTIONS.map((s, i) => (
            <Reveal key={s.code} delay={i * 0.08}>
              <Link
                to={s.path || "/guides"}
                className="bg-card rounded-2xl p-6 border border-border hover:border-foreground/15 hover:-translate-y-1 hover:shadow-lg transition-all duration-300 group h-full text-center block"
              >
                <div
                  className={`w-14 h-14 ${s.color} text-white rounded-2xl flex items-center justify-center font-bold text-xl mx-auto mb-4 font-mono group-hover:scale-105 transition-transform duration-300`}
                >
                  {s.code}
                </div>
                <h3 className="font-bold font-cabinet mb-1">{s.name}</h3>
                <p className="text-sm font-semibold text-primary mb-2 font-mono">
                  {s.questions}q &middot; {s.time}
                </p>
                <p className="text-xs text-muted-foreground font-plex">
                  {s.desc}
                </p>
                <div className="mt-3 text-xs text-muted-foreground font-mono">
                  Score: 300&ndash;900
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
